import { getWorkspaceMetadata } from "@/hooks/useWorkspace";

export type WorkspaceMetadata = Record<string, unknown> | null | undefined;

/** Aceita true / "true" / "1" / "yes" (com ou sem aspas no .env). */
function isTruthyFlag(value: unknown): boolean {
  if (value === true || value === 1) return true;
  if (typeof value !== "string") return false;
  const normalized = value.trim().toLowerCase().replace(/^["']|["']$/g, "");
  return normalized === "true" || normalized === "1" || normalized === "yes";
}

/**
 * Beta por workspace — `workspaces.metadata.multi_gcal_enabled = true`.
 * Permite habilitar multi-agenda sem `VITE_GCAL_MULTI_CALENDAR_ENABLED` global.
 *
 * Ativar via SQL (admin):
 *   UPDATE workspaces
 *   SET metadata = COALESCE(metadata, '{}'::jsonb) || '{"multi_gcal_enabled": true}'::jsonb
 *   WHERE id = '<workspace_uuid>';
 */
export function isWorkspaceMultiGcalEnabled(metadata: WorkspaceMetadata): boolean {
  return isTruthyFlag(metadata?.multi_gcal_enabled);
}

/**
 * Multi-agenda habilitada: env global OU beta por workspace.
 * Default false = mono-agenda idêntico ao legado (R6).
 */
export function isGcalMultiCalendarEnabled(metadata?: WorkspaceMetadata): boolean {
  if (isTruthyFlag(import.meta.env.VITE_GCAL_MULTI_CALENDAR_ENABLED)) return true;
  const meta = metadata ?? getWorkspaceMetadata();
  return isWorkspaceMultiGcalEnabled(meta);
}
